// layouts/AuthLayout.jsx

import React from "react";
import { FaUserCircle } from "react-icons/fa";
import { Images } from "../../Controller";

const AuthLayout = ({ title, subtitle, children, maxWidth = "max-w-md" }) => {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-8"
      style={{
        background:
          "linear-gradient(135deg, #366798 0%, #758ea8 35%, #859094 65%, #f89522 100%)",
      }}
    >
      <div className={`w-full ${maxWidth}`}>
        <div
          className="
            backdrop-blur-xl
            bg-white/10
            border border-white/20
            rounded-[40px]
            p-8
            shadow-2xl
          "
        >
          <div className="flex justify-center mb-6">
            <img
              src={Images.WebsiteLogo}
              className="w-[280px] h-auto"
              style={{ filter: "drop-shadow(0px 1px 2px #cfc8c8)" }}
            />
          </div>

          <h2 className="text-center text-white text-2xl font-semibold">
            {title}
          </h2>

          {subtitle && (
            <p className="text-center text-white/70 mt-2 text-base">
              {subtitle}
            </p>
          )}

          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
